import { action } from 'satcheljs';

const startSearchWithCategory = action(
    'startSearchWithCategory',
    (actionSource: string, categoryName: string) => ({
        actionSource: actionSource,
        categoryName: categoryName,
    })
);

export default startSearchWithCategory;
